import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import CursorGlow from "@/components/landing/CursorGlow";

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-white">
      <CursorGlow />
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "rgba(10,10,10,0.9)",
            border: "1px solid rgba(0,240,255,0.2)",
            color: "#fff",
            backdropFilter: "blur(12px)",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
